<template>
  <v-row>
    <v-col cols="12" class="text-right">
      <px-metabase-dashboard-filtro/>
    </v-col>
  </v-row>
</template>

<script>
import MetabaseDashboardFiltro from '@/modules/metabase/MetabaseDashboardFiltro.vue';

export default {
  components: {
    pxMetabaseDashboardFiltro: MetabaseDashboardFiltro,
  },
};
</script>
